<template lang="pug">
.base-alertas-bloco
    .alerta-bloco
        .alerta-bloco--esquerda
            .alerta-bloco--icone
                i.mdi.mdi-alert-circle-outline
            .bloco-dados
                .bloco-interno
                        slot
</template>

<script>
export default {
    name: 'BaseAlertasBloco',
    props: {
    },
    data() {
        return {
        };
    }
};
</script>

<style lang="scss" scoped>
.base-alertas-bloco {
    .alerta-bloco {
        background: #F7E1DF;
        display: flex;
        justify-content: space-between;
        border-radius: 8px;
        align-items: center;

        .alerta-bloco--esquerda {
            display: flex;

            .bloco-dados {
                margin: 0 8px;

                .bloco-interno {
                    display: flex;
                    align-items: center;
                    height: 100%;
                    flex-wrap: wrap;
                    color: #740F0F;

                    p {
                        margin: 0;
                        line-height: 17px;
                        display: flex;
                    }
                }
            }
        }
        
        .alerta-bloco--icone {
            background: rgba(250, 74, 59, 0.4);;
            width: 55px;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-top-left-radius: 8px;
            border-bottom-left-radius: 8px;
            .mdi {
                font-size: 27px;
                color:#740F0F;
            }
        }
    }
}
</style>
